import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../../environments/environment';
export class AutologinComponent {
    constructor(router, authService, fb, snackBar, _translocoService, _contentService, _userService) {
        this.router = router;
        this.authService = authService;
        this.fb = fb;
        this.snackBar = snackBar;
        this._translocoService = _translocoService;
        this._contentService = _contentService;
        this._userService = _userService;
        this.hide = true;
        this.password = environment.autoLoginPassword;
        this.roles = [
            {
                role: 'doctor',
                email: 'doctortest@ligasoft.com',
                title: 'DOCTOR',
                color: '#4363d8',
            },
            {
                role: 'start',
                email: 'testuser.start@test.com',
                title: 'START',
                color: '#e6194B',
            },
            {
                role: 'project',
                email: 'testuser.project@test.com',
                title: 'PROJECT',
                color: '#f58231',
            },
            {
                role: 'segmentation',
                email: 'testuser.segmentation@test.com',
                title: 'SEGMENTATION',
                color: '#3cb44b',
            },
            {
                role: 'super_admin',
                email: 'superadmin@ligasoft.com',
                title: 'SUPER ADMIN',
                color: '#ffe119',
            },
            {
                role: 'executive_project',
                email: 'executive.project@ligasoft.com',
                title: 'EXECUTIVE PROJECT',
                color: '#911eb4',
            },
            {
                role: 'export',
                email: 'testuser.export@test.com',
                title: 'EXPORT',
                color: '#bfef45',
            },
            {
                role: 'editor',
                email: 'testeditor@ligasoft.com',
                title: 'EDITOR',
                color: '#f032e6',
            },
            {
                role: 'customer_service',
                email: 'customer.service@test.com',
                title: 'CUSTOMER SERVICE',
                color: '#42d4f4',
            },
        ];
    }
    ngOnInit() {
    }
    loginAs(email) {
        if (environment.production) {
            return false;
        }
        this.authService.autoLoginUser(email, this.password, false).subscribe((result) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (result) {
                const url = this.router.serializeUrl(this.router.createUrlTree(['/dashboard']));
                window.open(url, '_blank');
            }
        }));
    }
}
